import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-audience-virtual-tour',
  templateUrl: './audience-virtual-tour.component.html',
  styleUrls: ['./audience-virtual-tour.component.scss']
})
export class AudienceVirtualTourComponent implements OnInit {

  centers;
  capacityData;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  constructor(
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private reportsTurnsService: ReportsTurnsService,
    private userStorageService: UserStorageService) {
      this.centers = this.userStorageService.getCenterList();
    }


  ngOnInit() {
    this.setBreadcrumb();
    this.getConnectivityTime(this.centers[6], new Date().valueOf(), new Date().valueOf());
  }

  private getConnectivityTime(center, from, to) {
    this.reportsTurnsService.waitingTimePerDesk(from, to, [center.InternalId]).pipe(
      tap((turnsWaitingTime) => {
          this.capacityData = turnsWaitingTime;
      })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.audience virutal tour'));
  }

}
